const sv = {
  dashboard: {
    title: "INSTRUMENTPANEL",
    greeting: "Hej",
    new_policy: "Ny försäkring",
    new_client: "Ny kund",
    clients_actifs: "Aktiva kunder",
    dossiers_etude: "Pågående ärenden",
    prime_annuelle: "Årspremie",
    polices_actives: "aktiva försäkringar",
    sinistres_ouverts: "öppna skador",
    a_traiter: "Ärenden att hantera",
    rien_a_traiter: "Inga väntande ärenden — allt är uppdaterat",
    portefeuille: "Portfölj",
    polices: "försäkringar",
    dash_st_validation: "Godkännande",
    dash_st_pieces: "Handlingar",
    dash_st_demande: "Begäran",
  },
  lang: { fr: 'Français', en: 'English', de: 'Deutsch', sv: 'Svenska' },

  nav: { rcpro_studies: "Granskningsärenden", gf_studies: "Granskningsärenden", gf_requests: "Öppningsbegäranden", gf_declarations: "Omsättningsdeklarationer",
    voyageur_subtitle: 'Komplettera ditt skadeärende',
    creer_acces_subtitle: 'Skapa ett konto så att resenären kan komplettera sitt ärende online.',
    acces_deja: 'Det finns redan ett resenärskonto för detta ärende',
    role_voyageur: 'Resenär',
    creer_acces_client: "Skapa kundkonto",
    creer_acces_client_subtitle: "Skapa ett konto så att kunden kan hantera sina försäkringar online.",
    acces_client_cree: "Kundkonto skapat — vidarebefordra inloggningsuppgifterna",
    acces_client_deja: "Det finns redan ett kundkonto för detta företag",
    client_space: "Min kundsida",
    client_mes_polices: "Mina försäkringar",
    role_client: "Kund",
    dashboard: "Instrumentpanel",
    section_pilotage: "Styrning",
    role_manager: 'Manager',
    role_souscripteur: 'Admin',
    role_accounts: 'Accounts',
    role_it: 'IT',
    role_courtier: 'Mäklare',
    role_client: 'Kund',
    section_sinistres: 'Skador',
    section_gestion: 'Hantering',
    section_portfolio: 'Portfölj',
    section_administration: 'Administration',
    utilisateurs: 'Användarkonton',
    intermediaires: 'Förmedlare',
    sinistres: 'Skadehantering',
    clients: 'Kunder',
    polices: 'Yrkesansvarsförsäkring',
    gf: 'Resegaranti',
    crm_subtitle: 'CRM',
    prestataires: 'Leverantörer & TOs',
    closed_dossiers: 'Avslutade ärenden',
    pending_payment: 'Väntar på betalning',
    pending_balances: 'Utestående saldon',
    pending_validation: 'Väntar på godkännande',
    gestion_doc: "Dokumenthantering",
  },

  common: { edit: "Redigera", modifier: "Redigera",
    saved: 'Sparat',
    ok: 'OK',
    save: 'Spara',
    saving: 'Sparar…',
    cancel: 'Avbryt',
    confirm: 'Bekräfta',
    delete: 'Ta bort',
    deleting: 'Tar bort…',
    open: 'Öppna',
    modify: 'Redigera',
    consult: 'Visa',
    generate: 'Skapa',
    close: 'Stäng',
    previous: '← Föregående',
    next: 'Nästa →',
    yes: 'Ja',
    no: 'Nej',
    loading: 'Laddar…',
    creating: 'Skapar…',
    slide: 'Steg',
    of: '/',
    all_countries: 'Alla länder',
    all_statuses: 'Alla statusar',
    actions: 'Åtgärder',
    status: 'Status',
    country: 'Land',
    none: '—',
    not_found: 'Hittades inte.',
    no_results: 'Inga resultat hittades.',
    error: 'Fel',
    access_denied: 'Åtkomst nekad',
    required: '*',
    optional: '(valfritt)',
    irreversible: 'Denna åtgärd kan inte ångras.',
    auto_generated: 'Automatiskt skapad',
    locked: 'Låst',
    consultation_only: '🔒 Endast läsning',
    generate_coming_soon: 'Mall under utveckling',
    download: '⬇ Skapa',
    locked_after_binding: '🔒 Tillgänglig efter tecknande',
    locked_after_activation: '🔒 Efter aktivering',
    yes_col: 'Ja',
    no_col: 'Nej',
    suspend: 'Pausa',
    reactivate: 'Återaktivera',
    unlock_btn: 'Lås upp',
    unlock_confirm: 'Återställa detta dokument till att vänta på godkännande?',
    doc_gf_cert_immat: "Registreringsbevis",
    doc_gf_statuts: "Bolagsordning",
    doc_gf_cv_dirigeant: 'CV för verkställande direktör',
    doc_gf_piece_id: "ID-handling för verkställande direktör",
    doc_gf_presentation_projet: 'Projektpresentation',
    doc_gf_previsionnel: "Detaljerad verksamhetsprognos",
    doc_gf_cgv: 'Allmänna villkor',
    doc_gf_presentation_activites: 'Verksamhetspresentation',
    doc_gf_previsionnel_annuel: "Verksamhetsprognos för året som ska garanteras",
    doc_gf_bilan_cr: 'Senaste årsredovisning och detaljerad resultaträkning',
    doc_gf_attestation_rcpro: 'Gällande intyg om yrkesansvarsförsäkring',
    doc_gf_attestation_fonds: 'Intyg om förvarade toppbelopp',
    readonly_banner: 'Skrivskyddad vy — endast uppladdning och visning',
    broker_readonly: 'Som mäklare kan du endast visa kundernas ärenden.',
    address_siege: 'Huvudkontorets adress',
    broker_status_locked: 'Intressent — status bestäms av Arcus handläggare',
    accepted_label: 'godkänd(a)',
    required_label: 'Krävs',
    delete_btn: '🗑 Ta bort',
    doc_contrat_reservation: "Kopia av bokningsavtal med resebyrån",
    doc_preuve_paiement: 'Betalningsbevis',
    doc_bon_voucher: 'Ej använd voucher (i förekommande fall)',
    delete_confirm: 'Ta bort',
    coming_soon: "Funktion kommer snart",
  },

  status: { devis_rcpro: "Offert (väntar på handlingar)", demande_pieces: "Handlingar & information begärda", en_cours_etude: "Under granskning", demande_ouverture: "Begäran väntar", demande_refusee: "Begäran avslagen",
    actif: 'Aktiv',
    suspendu: 'Pausad',
    prospect: 'Intressent',
    client_actif: 'Aktiv kund',
    devis: 'Offert',
    souscrit: 'Tecknad',
    resilie: 'Uppsagd',
    sans_objet: 'Ej tillämpligt',
    amende: 'Ändrad',
    projet_avenant: "Utkast till tilläggsavtal",
    avenant_actif: 'Aktivt tilläggsavtal',
    remplace: 'Ersatt',
    en_vigueur: 'Gällande',
    renouvellement: 'Förnyelse',
    en_souscription: 'Under tecknande',
    renouvelee: "Förnyad",
  },

  intermediaires: {
    title: 'Förmedlarhantering',
    create_btn: '+ Skapa förmedlare',
    search_placeholder: 'Sök efter namn, typ, registreringsnummer…',
    count: 'förmedlare',
    count_plural: 'förmedlare',
    not_assignable: '· Kan inte tilldelas en kund',
    col_name: 'NAMN / STRUKTUR',
    col_type: 'TYP',
    col_country: 'LAND',
    col_status: 'STATUS',
    col_actions: 'ÅTGÄRDER',
    type_courtier: 'Mäklare',
    type_avocat: 'Advokat',
    type_association: 'Förening',
    type_formation: 'Utbildningsanordnare',
    contacts_count: 'kontakt',
    contacts_count_plural: 'kontakter',
    unlock_btn: 'Lås upp',
    unlock_confirm: 'Återställa detta dokument till att vänta på godkännande?',
    doc_gf_cert_immat: "Registreringsbevis",
    doc_gf_statuts: "Bolagsordning",
    doc_gf_cv_dirigeant: 'CV för verkställande direktör',
    doc_gf_piece_id: "ID-handling för verkställande direktör",
    doc_gf_presentation_projet: 'Projektpresentation',
    doc_gf_previsionnel: "Detaljerad verksamhetsprognos",
    doc_gf_cgv: 'Allmänna villkor',
    doc_gf_presentation_activites: 'Verksamhetspresentation',
    doc_gf_previsionnel_annuel: "Verksamhetsprognos för året som ska garanteras",
    doc_gf_bilan_cr: 'Senaste årsredovisning och detaljerad resultaträkning',
    doc_gf_attestation_rcpro: 'Gällande intyg om yrkesansvarsförsäkring',
    doc_gf_attestation_fonds: 'Intyg om förvarade toppbelopp',
    readonly_banner: 'Skrivskyddad vy — endast uppladdning och visning',
    broker_readonly: 'Som mäklare kan du endast visa kundernas ärenden.',
    address_siege: 'Huvudkontorets adress',
    broker_status_locked: 'Intressent — status bestäms av Arcus handläggare',
    accepted_label: 'godkänd(a)',
    required_label: 'Krävs',
    delete_btn: '🗑 Ta bort',
    doc_contrat_reservation: "Kopia av bokningsavtal med resebyrån",
    doc_preuve_paiement: 'Betalningsbevis',
    doc_bon_voucher: 'Ej använd voucher (i förekommande fall)',
    delete_confirm: 'Är du säker på att du vill ta bort',
    new_title: 'Ny förmedlare',
    edit_title: "Redigera förmedlare",
    breadcrumb: 'Förmedlare',
    tab_profile: "Förmedlaren",
    tab_contacts: 'Kontakterna',
    tab_contract: 'Avtalsvillkor',
    type_label: 'Typ *',
    courtier_fields_title: 'SPECIFIKA FÄLT — MÄKLARE',
    professional_number: 'Registreringsnummer',
    reference_code: 'Mäklarens referenskod',
    professional_number_placeholder: 'T.ex. CIF-FR-123456',
    reference_code_placeholder: 'T.ex. ARC-2024-001',
    structure_name: 'Strukturens namn *',
    legal_status: 'Bolagsform',
    registration_number: "Organisationsnummer",
    registration_placeholder: 'T.ex. 559123-4567',
    addresses: 'ADRESSER',
    main_address: '🏠 Huvudadress',
    add_address: '+ Lägg till adress',
    address_line1: 'Adress 1',
    address_line2: 'Adress 2',
    postal_code: 'Postnummer',
    city: 'Stad',
    address1_placeholder: 'Gatunummer och gata',
    address2_placeholder: 'Tillägg (valfritt)',
    postal_placeholder: '11122',
    title_contact: 'Titel',
    role: 'Status / Funktion',
    first_name: 'Förnamn',
    last_name: 'Efternamn *',
    email: 'E-post',
    phone: 'Telefon',
    comm_recipient: 'Mottagare av meddelanden',
    main_contact: 'Huvudkontakt',
    add_contact: '+ Lägg till kontakt',
    remunerated: 'Arvoderad förmedlare?',
    remunerated_desc: "Om ja, tillämpas en provisionssats på de förmedlade avtalen.",
    commission_rate: 'Provisionssats *',
    commission_auto: 'Provisionen tillämpas automatiskt på tillhörande avtal.',
    not_remunerated_info: "Ingen provision genereras för denna förmedlare.",
    suspension_date: 'Datum för pausning',
  },

  clients: {
    title: 'Kundhantering',
    create_btn: '+ Skapa kund',
    search_placeholder: 'Sök efter namn, verksamhet, land…',
    count: 'kund',
    count_plural: 'kunder',
    col_name: 'NAMN / FÖRETAG',
    col_activity: 'HUVUDVERKSAMHET',
    col_relation: 'RELATION',
    col_country: 'LAND',
    col_status: 'STATUS',
    col_actions: 'ÅTGÄRDER',
    via: 'via',
    new_title: 'Ny kund',
    edit_title: 'Redigera kund',
    breadcrumb: 'Kunder',
    tab_relation: 'Relationen',
    tab_company: "Företaget",
    tab_contacts: 'Kontakterna',
    tab_activities: 'Verksamheterna',
    client_status: 'Kundstatus',
    client_status_desc: 'Bestämmer uppföljningsnivå och tillgängliga åtgärder.',
    market: 'Marknad *',
    market_placeholder: '— Välj land —',
    relation_type: 'Relationstyp *',
    direct: 'Direkt',
    brokered: 'Förmedlad',
    broker_label: 'Mäklare *',
    broker_placeholder: '— Välj mäklare —',
    broker_auto_commission: 'Mäklarens provisionssats tillämpas automatiskt på försäkringarna.',
    third_party: 'TREDJE PART',
    third_party_desc: "Välj om en tredje part är involverad i relationen (advokat, förening, annat). Flera val möjliga.",
    company_name: "Företagsnamn *",
    company_placeholder: 'T.ex. Världens Resor AB',
    legal_status: 'Bolagsform',
    registration: "Organisationsnummer",
    registration_placeholder: 'T.ex. 559123-4567',
    unlock_btn: 'Lås upp',
    unlock_confirm: 'Återställa detta dokument till att vänta på godkännande?',
    doc_gf_cert_immat: "Registreringsbevis",
    doc_gf_statuts: "Bolagsordning",
    doc_gf_cv_dirigeant: 'CV för verkställande direktör',
    doc_gf_piece_id: "ID-handling för verkställande direktör",
    doc_gf_presentation_projet: 'Projektpresentation',
    doc_gf_previsionnel: "Detaljerad verksamhetsprognos",
    doc_gf_cgv: 'Allmänna villkor',
    doc_gf_presentation_activites: 'Verksamhetspresentation',
    doc_gf_previsionnel_annuel: "Verksamhetsprognos för året som ska garanteras",
    doc_gf_bilan_cr: 'Senaste årsredovisning och detaljerad resultaträkning',
    doc_gf_attestation_rcpro: 'Gällande intyg om yrkesansvarsförsäkring',
    doc_gf_attestation_fonds: 'Intyg om förvarade toppbelopp',
    readonly_banner: 'Skrivskyddad vy — endast uppladdning och visning',
    broker_readonly: 'Som mäklare kan du endast visa kundernas ärenden.',
    address_siege: 'Huvudkontorets adress',
    broker_status_locked: 'Intressent — status bestäms av Arcus handläggare',
    accepted_label: 'godkänd(a)',
    required_label: 'Krävs',
    delete_btn: '🗑 Ta bort',
    doc_contrat_reservation: "Kopia av bokningsavtal med resebyrån",
    doc_preuve_paiement: 'Betalningsbevis',
    doc_bon_voucher: 'Ej använd voucher (i förekommande fall)',
    delete_confirm: "Denna kund har aktiva försäkringar. Ta bort dem först.",
    contacts_section: 'Kontakterna',
    main_contact: 'Huvudkontakt',
    contact_number: 'Kontakt',
    add_contact: '+ Lägg till kontakt',
    title_contact: 'Titel',
    role: 'Status / Funktion',
    first_name: 'Förnamn',
    last_name: 'Efternamn *',
    email: 'E-post',
    phone: 'Telefon',
    comm_recipient: 'Mottagare av meddelanden',
    activities_section: 'Verksamheterna',
    principal_activity: 'Huvudverksamhet',
    principal_activity_desc: "Resebyråns dominerande verksamhet (enstaka val)",
    secondary_activities: 'Sekundära verksamheter',
    secondary_activities_desc: 'Övriga utövade verksamheter (flerval)',
    no_activity_selected: "Välj först en huvudverksamhet",
  },

  client_detail: {
    modify_fiche: 'Redigera ärende',
    legal_status: 'Bolagsform',
    registration: 'Org.nr',
    market: 'Marknad',
    distribution: 'Distribution',
    direct_distribution: 'Direkt (+15 % Arcus)',
    brokered_distribution: 'Förmedlad',
    address_label: '📍',
    policies_title: "Försäkringar",
    contract_count: 'avtal',
    contract_count_plural: 'avtal',
    create_policy: '+ Ny yrkesansvarsförsäkring',
    no_policies: 'Inga försäkringar för denna kund. Klicka på "Ny försäkring" för att skapa en offert.',
    col_piece: 'BELÄGGS-NR',
    col_status: 'STATUS',
    col_premium: 'BRUTTOPREMIE',
    col_effect: "STARTDATUM",
    col_expiry: 'FÖRFALLODAG',
    col_actions: 'ÅTGÄRDER',
    renew: '🔄 Förnya',
    terminate: 'Säg upp',
    amendment_prefix: 'Tilläggsavtal nr',
    new_amendment: '✎ Nytt tilläggsavtal',
    expiry_warning: '⚠',
    renewal_line: "Förnyad den",
    collapse: "Fäll ihop",
    expand: "Fäll ut",
    previous_period: "Föregående period",
  },

  polices: {
    title: 'Yrkesansvarsförsäkring',
    breadcrumb: 'Försäkringar',
    portfolio_title: 'Yrkesansvarsportfölj',
    create_from_client: 'Försäkringar skapas från kundärendet',
    col_client: 'KUND / FÖRSÄKRINGSNR',
    col_country: 'LAND',
    col_premium: 'BRUTTOPREMIE',
    col_expiry: 'FÖRFALLODAG',
    col_status: 'STATUS',
    tab_policy: 'Försäkringen',
    tab_tarification_gf: 'Prissättning',
    tarif_add_period: '+ Lägg till period',
    tarif_period: 'Period',
    tarif_date_debut: 'Startdatum',
    tarif_date_fin: 'Slutdatum',
    tarif_exposition: 'Exponering (€)',
    tarif_taux: 'Sats (%)',
    tarif_prime_ht: 'Nettopremie',
    tarif_taxe: 'Skatt (9%)',
    tarif_prime_ttc: 'Bruttopremie',
    tarif_total: 'TOTAL BRUTTOPREMIE',
    tarif_hint: 'Nettopremie = Exponering × Sats · Skatt = 9% · Bruttopremie = Nettopremie + Skatt',
    tab_underwriting: 'Informationsinsamling',
    tab_tarification: 'Prissättning',
    tab_documents: 'Dokument',
    client_readonly: 'Kund — kan inte ändras',
    risk_insured_title: 'Är risken redan försäkrad?',
    risk_insured_yes: 'Övertag från konkurrent — skadehistorik obligatorisk',
    risk_insured_no: 'Förstagångsteckning',
    current_insurer: 'Nuvarande försäkringsgivare *',
    policy_status: 'Försäkringsstatus',
    quote_number: 'Offertnummer',
    policy_number: 'Försäkringsnummer',
    policy_number_required: 'Krävs för att få tillgång till prissättning',
    effect_date: "Startdatum *",
    expiry_date: "Förfallodag",
    expiry_auto: '(auto +1 år)',
    renewal_note: '🔄 Förnyelse genom årlig tyst förlängning.',
    locked_banner: 'Tecknat avtal (endast visning)',
    renewal_banner: '🔄 Förnyelse — period',
    to: 'till',
    create_amendment: '✎ Skapa tilläggsavtal',
    renew_btn: '🔄 Förnya',
    terminate_btn: 'Säg upp',
    move_to_bound: 'Sätt till Tecknad',
    confirm_binding_title: '⚠ Bekräfta tecknande',
    confirm_binding_desc: 'Du är på väg att teckna detta avtal.',
    confirm_binding_warning: 'Alla fält kommer att låsas.',
    renewal_title: '🔄 Skapa förnyelse',
    renewal_question: 'Vill du förnya detta avtal på samma villkor som',
    renewal_last_active: 'senaste aktiva versionen',
    renewal_same: '✓ Ja — samma villkor',
    renewal_same_desc: 'Förnyelsen tar över alla aktuella värden. Nya datum sätts automatiskt.',
    renewal_new: '✎ Nej — nya villkor',
    renewal_new_desc: "Formuläret öppnas förifyllt. Du anger den nya omsättningen.",
    declared_ca: 'Deklarerad omsättning (€) *',
    payment_freq: 'Betalningsperiod',
    loading_factors: "Frågor om verksamheterna",
    discount_factors: 'Rabattfaktorer',
    covered_activities: "Utförda verksamheter",
    special_conditions: 'Särskilda villkor',
    special_conditions_hint: 'Om tomt → "Inga" i dokumentet.',
    special_conditions_placeholder: 'Särskild klausul som ska visas i avtalet…',
    loss_history: 'Skadehistorik',
    loss_takeover: 'Övertag · Försäkringsgivare',
    loss_closed: 'Avslutade skador (> 1 500 €)',
    loss_open: 'Öppna skador (> 1 500 €)',
    loss_total_paid: 'Totalt utbetalt (€)',
    loss_count: 'Antal',
    loss_provision: 'Reserverat (€)',
    loss_partial: 'Delbetalt (€)',
    loss_years: 'År i utdraget',
    net_premium: 'Nettopremie',
    commission: 'Provision',
    tax: 'Skatt',
    gross_premium: 'Bruttopremie',
    above_ceiling: "⚠ Omsättning över 10 M€ — lämna direkt till försäkringsgivaren.",
    enter_ca: 'Ange omsättning för att visa premieberäkningen.',
    floor_applied: '· Lägsta belopp 600 € tillämpas',
    global_coeff: 'Total koeff.',
    freq_annual: 'Årlig (+0 %)',
    freq_semi: 'Halvårsvis (+2 %)',
    freq_quarter: 'Kvartalsvis (+4 %)',
    freq_month: 'Månadsvis (+6 %)',
    internal_notes: 'Interna anteckningar',
    notes_placeholder: "Tecknandeanteckningar, särskilda villkor…",
    maj_q1: 'Mer än 50 % av omsättningen kopplad till sportresor, bröllop, möhippor / svensexor?',
    maj_q2: '50 % eller mer av passagerarna / omsättningen till länder utanför EU, Skandinavien, Schweiz, AUS, NZ?',
    maj_q3: 'Utökat skydd USA / Kanada?',
    maj_q4: 'Gruppresor med mer än 10 personer?',
    maj_q5: '50 % eller mer av vistelserna innehåller icke-standardtransport (4×4, båt, flyg)?',
    maj_q6: '50 % eller mer av vistelserna innehåller riskaktiviteter (skidåkning, dykning, fallskärm…)?',
    min_q1: 'Skadefri historik de senaste 48 månaderna?',
    min_q2: "Verkställande direktör med mer än 10 års erfarenhet inom resebyrå eller researrangör?",
    act1: 'Biljettförsäljning',
    act2: "Organisation av vistelser eller resor i Frankrike eller utomlands",
    act3: 'Försäljning av vistelser eller resor som organiseras av researrangör',
    act4: "Inkommande turism",
    act5: "Provisionsförsäljning (hotell, biluthyrning, assistans, teater…)",
    doc_language: '🌐 Språk: Franska · Fransk rätt gäller',
    doc_devis_warning: '⚠ Status Offert — Försäkring och intyg tillgängliga efter tecknande.',
    doc_locked_docs: 'Avtalshandlingar',
    doc_project: "Försäkringsutkast",
    doc_project_desc: 'Presentationsdokument för offerten',
    doc_policy: 'Särskilda villkor',
    doc_cg: 'Allmänna villkor',
    doc_attestation: "Försäkringsintyg",
    doc_attestation_desc: 'Bevis på yrkesansvarsskydd',
    direct_plus15: 'Direkt · +15 % Arcus',
    brokered_comm: 'Förmedlad · % mäklare',
    broker_view_banner: 'Mäklarvy — endast visning och uppladdning av dokument',
    broker_docs_locked: '🔒 Tillgänglig efter tecknande',
    confirm_binding_docs_missing: 'Obligatoriska dokument är inte godkända — tecknande omöjligt',
    doc_waiting_approval: 'Uppladdat men väntar på godkännande',
    doc_not_uploaded: 'Ej uppladdat',
    docs_in_french: 'Handlingar på franska',
    warn_date_effet_locked: "Ändring möjlig men känslig — kontrollera påverkan på tilläggsavtal och eventuell förnyelse",
    // ── Workflow étude/souscription RC Pro ──
    etude_title: "Ärendegranskning",
    etude_locked_note: "Avsnitt låst — försäkringen är tecknad.",
    numero_projet: "Projektnummer",
    date_effet_prev: "Preliminärt ikraftträdandedatum",
    rcpro_step_devis: "Offert (inväntar handlingar)",
    rcpro_step_devis_hint: "Mäklaren/kunden fyller i ärendet och skickar det till Arcus.",
    rcpro_step_etude_hint: "Nås när mäklaren/kunden skickar in teckningsbegäran.",
    repasser_devis_btn: "Återgå till Offert",
    repasser_devis_confirm_title: "Återställa ärendet till Offert?",
    repasser_devis_confirm_desc: "Formuläret blir redigerbart igen för mäklaren/kunden; redan ifylld information behålls. Ärendet återgår till statusen ”Offert (inväntar handlingar)”.",
    repasser_devis_confirm_btn: "Återställ",
    police_locked_note: "Avsnittet aktiveras när försäkringen tecknas.",
    souscrire_btn: "Teckna försäkringen",
    souscrire_need_date: "Ange ikraftträdandedatum.",
    souscrire_need_npolice: "Ange försäkringsnummer.",
    souscrire_confirm_title: "Teckna försäkringen",
    souscrire_confirm_desc: "Bekräfta uppgifterna nedan för att skapa försäkringen. Avsnittet ”Försäkring” aktiveras och granskningen låses.",
    souscrire_date_label: "Försäkringens ikraftträdandedatum",
    souscrire_npolice_label: "Försäkringsnummer",
    souscrire_confirm_btn: "Teckna",
    // ── RC Pro : onglet Souscription + mention spéciale ──
    ajustement_title: "Prisjustering",
    ajustement_hint: "Frivillig premiehöjning (kan inte sänka den).",
    ajustement_coeff: "Koefficient (t.ex. 1,25 = +25 %)",
    ajustement_min_note: "Minimum 1,00 (ingen sänkning)",
    discount_hint: "Kryssa för att tillämpa rabatten på den aktuella offerten.",
    dossier_decline_banner: "Ärende avvisat — risken avvisades av Arcus.",
    dossier_decline_status: "Ärende avvisat",
    exclusion_title: "\"Festligt\"-undantag",
    exclusion_remove_label: "Ta bort undantaget",
    exclusion_text: "Organisering, försäljning eller vidareförsäljning av festliga resor/vistelser såsom svensexor/möhippor, spring break, studentföreningsresor…",
    exclusion_present_note: "Undantaget finns i försäkringsförslaget.",
    exclusion_removed_note: "Undantaget är borttaget och visas inte i försäkringsförslaget.",
    mention_approve: "Godkänn",
    mention_approved: "Anmärkning godkänd av Arcus.",
    mention_client_request: "Kundens / mäklarens begäran",
    mention_none: "Ingen begäran om särskild anmärkning.",
    mention_pending: "Begäran skickad till Arcus Solutions — inväntar behandling.",
    mention_reformulate: "Omformulera",
    mention_reformulate_confirm: "Bekräfta omformulering",
    mention_reformulate_empty: "Ange omformuleringen.",
    mention_reformulate_label: "Omformulering av anmärkningen",
    mention_reformulated: "Anmärkning omformulerad av Arcus.",
    mention_refuse: "Avvisa risken",
    mention_refused: "Risk avvisad — ärende avvisat.",
    mention_submit_btn: "Skicka begäran till Arcus Solutions",
    mention_submit_confirm_title: "Skicka begäran till Arcus?",
    mention_submit_confirm_desc: "Din begäran skickas till Arcus Solutions för granskning. Ärendet låses och inget dokument kan laddas ner förrän Arcus beslutar.",
    mention_submit_confirm_btn: "Skicka begäran",
    tab_souscription: "Teckning",
  },

  resiliation: {
    title: 'Säg upp avtalet',
    title_amendment: "Säg upp tilläggsavtalet",
    motif_label: 'Uppsägningsorsak *',
    motif_echeance: "Uppsägning vid förfallodag",
    motif_echeance_desc: "Avtalet sägs upp vid förfallodatum.",
    motif_disparition: 'Risken upphör',
    motif_disparition_desc: 'Ange uppsägningsdatum. Pro rata beräknas automatiskt.',
    motif_aggravation: 'Riskökning',
    motif_aggravation_desc: 'Meddelandedatum obligatoriskt. Uppsägning 10 dagar senare. Pro rata beräknas.',
    motif_nonpaiement: 'Utebliven betalning',
    motif_nonpaiement_desc: 'Ange uppsägningsdatum. Ingen återbetalning av premie.',
    notif_date: 'Meddelandedatum *',
    resil_date: 'Uppsägningsdatum *',
    j_plus_10: '(D+10)',
    prorata_title: 'Pro rata temporis',
    prorata_total: 'Total löptid',
    prorata_remaining: 'Återstående dagar',
    prorata_refund: 'Att återbetala',
    prorata_days: 'dagar',
    note_label: 'Intern anteckning',
    note_placeholder: 'Sammanhang för uppsägningen…',
    confirm_btn: '✓ Bekräfta uppsägning',
  },

  amendements: {
    tab_amendment: "Tilläggsavtalet",
    tab_tarification_gf: 'Prissättning',
    tarif_add_period: '+ Lägg till period',
    tarif_period: 'Period',
    tarif_date_debut: 'Startdatum',
    tarif_date_fin: 'Slutdatum',
    tarif_exposition: 'Exponering (€)',
    tarif_taux: 'Sats (%)',
    tarif_prime_ht: 'Nettopremie',
    tarif_taxe: 'Skatt (9%)',
    tarif_prime_ttc: 'Bruttopremie',
    tarif_total: 'TOTAL BRUTTOPREMIE',
    tarif_hint: 'Nettopremie = Exponering × Sats · Skatt = 9% · Bruttopremie = Nettopremie + Skatt',
    tab_underwriting: 'Informationsinsamling',
    tab_documents: 'Dokument',
    replaced_contract: 'Ersatt avtal',
    current_policy: 'Försäkringsnr',
    current_premium: 'Aktuell bruttopremie',
    client: 'Kund',
    effect_date: "Tilläggsavtalets startdatum *",
    effect_date_hint: 'Fri inmatning — kan vara retroaktivt eller framtida.',
    notes_label: "Interna anteckningar (anledning till tilläggsavtalet)",
    notes_placeholder: "T.ex.: Verksamhetsändring, omsättningsökning…",
    comparison_title: '⇄ Jämförelse med pågående avtal',
    current_contract: 'Aktuellt avtal',
    amendment_label: 'Tilläggsavtal',
    difference: 'Skillnad',
    increase_msg: '↑ Ökning · Tilläggsfaktura',
    decrease_msg: '↓ Minskning · Justering till 0 € — ingen återbetalning',
    stable_msg: '= Identisk premie — tilläggsavtal utan ekonomisk påverkan',
    activate_btn: 'Aktivera',
    activate_disabled: "Startdatum krävs för aktivering",
    confirm_activate_title: "⚠ Bekräfta aktivering",
    confirm_activate_desc: 'kommer att ersätta det aktuella avtalet.',
    confirm_activate_irreversible: 'Det ursprungliga avtalet arkiveras.',
    locked_banner: '🔒 Tilläggsavtal aktivt — fält låsta (endast visning).',
    doc_project: "Utkast till tilläggsavtal",
    doc_project_desc: 'Presentationsdokument',
    doc_project_warning: "⚠ Status Utkast — Avtalshandlingar låses upp efter aktivering.",
    doc_section_project: 'Projektakt',
    doc_section_contracts: 'Avtalshandlingar',
    doc_appel_section: 'Tilläggsfaktura / Justering',
    doc_appel_title: 'Tilläggsfaktura',
    doc_appel_amount: 'Belopp',
    doc_regularisation: 'Justeringsbrev',
    doc_regularisation_desc: "Justering till 0 € — ingen tilläggsfaktura",
    delete_title: "Ta bort tilläggsavtalet",
    unlock_btn: 'Lås upp',
    unlock_confirm: 'Återställa detta dokument till att vänta på godkännande?',
    doc_gf_cert_immat: "Registreringsbevis",
    doc_gf_statuts: "Bolagsordning",
    doc_gf_cv_dirigeant: 'CV för verkställande direktör',
    doc_gf_piece_id: "ID-handling för verkställande direktör",
    doc_gf_presentation_projet: 'Projektpresentation',
    doc_gf_previsionnel: "Detaljerad verksamhetsprognos",
    doc_gf_cgv: 'Allmänna villkor',
    doc_gf_presentation_activites: 'Verksamhetspresentation',
    doc_gf_previsionnel_annuel: "Verksamhetsprognos för året som ska garanteras",
    doc_gf_bilan_cr: 'Senaste årsredovisning och detaljerad resultaträkning',
    doc_gf_attestation_rcpro: 'Gällande intyg om yrkesansvarsförsäkring',
    doc_gf_attestation_fonds: 'Intyg om förvarade toppbelopp',
    readonly_banner: 'Skrivskyddad vy — endast uppladdning och visning',
    broker_readonly: 'Som mäklare kan du endast visa kundernas ärenden.',
    address_siege: 'Huvudkontorets adress',
    broker_status_locked: 'Intressent — status bestäms av Arcus handläggare',
    accepted_label: 'godkänd(a)',
    required_label: 'Krävs',
    delete_btn: '🗑 Ta bort',
    doc_contrat_reservation: "Kopia av bokningsavtal med resebyrån",
    doc_preuve_paiement: 'Betalningsbevis',
    doc_bon_voucher: 'Ej använd voucher (i förekommande fall)',
    delete_confirm: "Är du säker på att du vill ta bort tilläggsavtalet",
    resiliation_info_title: 'Uppsagt tilläggsavtal',
    resiliation_motif: 'Orsak',
    resiliation_date: 'Datum',
    resiliation_prorata: 'Pro rata',
    new_amendment: '✎ Nytt tilläggsavtal',
  },

  documents: {
    cp: 'SV',
    attestation: 'Intyg',
    cg: 'AV',
    policy: 'Särskilda villkor',
    general_conditions: 'Allmänna villkor',
    certificate: "Försäkringsintyg",
    quote: "Försäkringsutkast",
  },

  auth: {
    forgot_password: "Glömt lösenord?",
    forgot_title: "Glömt lösenord",
    forgot_desc: "Ange din e-post så skickar vi en länk för att skapa ett nytt lösenord.",
    forgot_btn: "Skicka länk",
    forgot_sent: "Om ett konto finns med denna adress har en återställningslänk just skickats.",
    back_to_login: "Tillbaka till inloggning",
    reset_title: "Nytt lösenord",
    reset_desc: "Välj ett säkert lösenord (minst 8 tecken).",
    reset_btn: "Skapa lösenord",
    reset_success: "Lösenord skapat. Du kan nu logga in.",
    redirecting: "Omdirigerar till inloggningssidan…",
    password_mismatch: "Lösenorden stämmer inte överens.",
    password_too_short: "Minst 8 tecken.",
    email_required: "E-post krävs.",
    welcome: 'Välkommen',
    sign_in_desc: 'Logga in på ditt ARCUSCONNECT-konto',
    email: 'E-postadress',
    email_placeholder: 'din@email.se',
    password: 'Lösenord',
    password_placeholder: '••••••••',
    sign_in: 'Logga in',
    signing_in: 'Loggar in…',
    logout: 'Logga ut',
    fill_all: 'Fyll i alla fält',
    access_levels: "Behörighetsnivåer",
    change_password: 'Ändra lösenord',
    current_password: 'Nuvarande lösenord',
    new_password: 'Nytt lösenord',
    confirm_password: 'Bekräfta lösenord',
    password_changed: 'Lösenordet har ändrats',
  },
  sinistres: {
    title: 'Skadehantering',
    subtitle: "Ersättningsförfaranden efter resebyråers konkurs",
    open_procedure: 'Öppna förfarande',
    filter_all: 'Alla',
    col_numero: 'Förfarande-nr', col_agence: 'Resebyrå', col_statut: 'Status',
    col_date_ouv: "Öppningsdatum", col_date_fin: 'Slut på ersättning', col_actions: 'Åtgärder',
    no_procedures: 'Inga skadeförfaranden registrerade.',
    open_btn: 'Öppna', loading: 'Laddar…',
    modal_title: 'Öppna förfarande',
    modal_subtitle: "Välj den insolventa resebyrån och fastställ förfarandets datum.",
    select_agence: '— Välj resebyrå —',
    date_ouverture: "Öppningsdatum *", date_fin: 'Slutdatum för ersättning',
    notes: 'Interna anteckningar (valfritt)', notes_placeholder: 'Sammanhang, användbar information…',
    valider: 'Bekräfta →', creation: 'Skapar…',
    confirm_title: 'Bekräftelse krävs', confirm_subtitle: 'Oåterkallelig åtgärd — endast Manager',
    confirm_about: "Du är på väg att officiellt öppna skadeförfarandet för:",
    confirm_warning: "⚠ Denna åtgärd kommer att låsa resebyrån permanent och kan inte ångras.",
    confirm_no_manager: "Endast ett Manager-konto kan bekräfta denna öppning.",
    annuler_procedure: '✕ Avbryt förfarande',
    confirmer_ouverture: "✓ Bekräfta öppning", confirmation_loading: 'Bekräftar…',
    agence_locked: 'Resebyrå låst', procedure_label: 'Skadeförfarande',
    cloturer: 'Avsluta förfarande', infos_procedure: 'Förfarandeinformation',
    modifier: '✎ Redigera', tracabilite: 'Spårbarhet',
    cree: 'Förfarande skapat', confirmee: 'Förfarande bekräftat och öppnat',
    cloturee_label: 'Förfarande avslutat', par: 'av',
    cloturer_confirm_title: 'Avsluta förfarandet?',
    cloturer_confirm_body: 'Förfarandet markeras som avslutat. Denna åtgärd kan inte ångras.',
    cloturer_btn: 'Avsluta', pending_alert: 'Väntar på Manager-bekräftelse',
    pending_desc: "Detta förfarande har skapats men är ännu inte officiellt öppnat.",
    statut_ouverture_pendante: 'Väntar på bekräftelse',
    statut_ouverte: 'Förfarande öppnat', statut_cloturee: 'Avslutat',
    dossiers_title: "Ersättningsärenden",
    ajouter_dossier: '+ Lägg till ärende',
    no_dossiers: 'Inget ärende registrerat. Klicka på "+ Lägg till ärende" för att börja.',
    pending_dossiers: "Förfarandet måste bekräftas av en Manager innan ärenden kan läggas till.",
    col_souhait: 'Önskemål',
    col_montant_total: 'Resebelopp',
    col_acompte: 'Erlagd handpenning',
    col_solde: 'Återstående saldo',
    col_numero_dossier: 'Ärende-nr', col_voyageur: 'Förmånstagare', col_type: 'Typ',
    nouveau_dossier: 'Nytt ärende',
    nouveau_dossier_subtitle: 'Registrera en ny förmånstagare av resegarantin.',
    type_beneficiaire: 'Typ av förmånstagare',
    particulier: '👤 Privatperson', professionnel: '🏢 Företag',
    nom_particulier: 'Efternamn / Förnamn *', nom_professionnel: 'Företagsnamn *',
    creer_dossier: 'Skapa ärende →', creation_dossier: 'Skapar…',
    statut_dossier: 'Ärendestatus', reserved_manager: 'Endast Manager',
    validation_required: 'Manager-godkännande krävs',
    validation_desc: 'Detta ärende är klart för slutgodkännande före betalning.',
    decliner: '✕ Avvisa', valider_paiement: '✓ Godkänn betalning',
    pieces_title: 'Underlag',
    pieces_desc: 'Uppladdning och godkännande av förmånstagarens dokument',
    finances_title: 'Ekonomiska uppgifter',
    finances_desc: 'Resebelopp, erlagda handpenningar, ersättning som ska utbetalas',
    banque_title: 'Bankuppgifter',
    banque_desc: 'IBAN, kontoinnehavare, bankinstitut',
    a_developper: 'Under utveckling',
    voyageur_info: 'Förmånstagarens information',
    benef_intro: 'Vänligen besvara följande frågor.',
    submit_blocked_hint: 'Fyll i de obligatoriska uppgifterna och lämna alla underlag för att kunna skicka in.',
    submit_missing_title: 'För att skicka in ditt ärende återstår att fylla i:',
    submit_missing_fields: 'Obligatoriska uppgifter som saknas:',
    submit_missing_pieces: 'Underlag att lämna in:',
    piece_label_generic: 'Underlag',
    passer_en_cours: 'Sätt under behandling',
    passer_en_cours_title: 'Sätt ärendet under behandling?',
    passer_en_cours_desc: 'Ärendet flyttas till statusen ”Under behandling”, så att du kan fortsätta hantera det utan att vänta på att resenären skickar in. Kom ihåg att spara dina ändringar först.',
    benef_date_depart: 'Resans avresedatum',
    benef_carte_warning: 'Vänligen gör en återbetalningsbegäran eller ett klagomål enligt artikel 75. Om din utfärdande bank eller kortleverantör har avslagit din begäran, vänligen tillhandahåll bevis eller mottagningsbevis för detta avslag som en del av ditt ärende.',
    benef_voyageurs_label: 'Berörda resenärer',
    benef_add_voyageur: 'Lägg till en resenär',
    benef_voyageurs_groupe: 'Om det rör sig om en grupp på fler än 10 personer, vänligen tillhandahåll listan över resenärer tillsammans med styrkande handlingar i nästa avsnitt.',
    voyageur_titre: 'Titel',
    voyageur_nom: 'Efternamn',
    voyageur_prenom: 'Förnamn',
    voyageur_email: 'E-postadress',
    voyageur_telephone: 'Telefon',
    voyageur_titre_m: 'Herr',
    voyageur_titre_mme: 'Fru',
    voyageur_titre_mmme: 'Herr / Fru',
    voyageur_titre_ste: 'Företag',
    voyageur_titre_asso: 'Förening',
    voyage_info: 'Reseinformation',
    voyage_intro: 'Kontrollera uppgifterna från anmälaren och fyll i återstående fält med hjälp av resedokumenten. Korrigera vid behov avsnittet Reseinformation.',
    voyage_montant_total: 'Resans totalbelopp (€)',
    voyage_acompte: 'Erlagd handpenning (€)',
    voyage_solde: 'Återstående saldo (€)',
    voyage_solde_auto: 'Automatiskt beräknat: Totalbelopp − Handpenning',
    voyage_appel_fonds: 'Skapa medelsbegäran',
    voyage_appel_fonds_title: 'Medelsbegäran',
    voyage_appel_fonds_soon: "Mallen för medelsbegäran håller på att förberedas.",
    voyage_appel_fonds_preview: 'Förhandsgranskning — som information',
    voyage_appel_fonds_email: 'Skicka via e-post',
    voyage_appel_fonds_copy: 'Kopiera',
    voyage_appel_fonds_copied: 'Kopierat!',
    souhait_label: 'Resenärens önskemål',
    souhait_remboursement: 'Återbetalning',
    souhait_maintien: 'Behåll resan',
    souhait_rapatriement: 'Hemtransport',
    paiement_title: 'Betalningshantering',
    paiement_type: 'Typ av mottagare',
    paiement_nom: 'Efternamn',
    paiement_prenom: 'Förnamn',
    paiement_adresse: 'Adress',
    paiement_cp: 'Postnummer',
    paiement_ville: 'Stad',
    paiement_iban: 'IBAN',
    paiement_swift: 'SWIFT- / BIC-kod',
    paiement_reference: 'Betalningsreferens',
    paiement_ref_auto: 'Automatiskt skapad',
    paiement_montant: 'Belopp att betala (€)',
    paiement_ajouter: '+ Lägg till betalning',
    paiement_numero: 'Betalning nr',
    paiement_aucun: 'Ingen betalning registrerad.',
    paiement_particulier: 'Privatperson',
    paiement_professionnel: 'Företag',
    supprimer_dossier: 'Ta bort ärendet',
    supprimer_dossier_confirm: 'Är du säker på att du vill ta bort detta ärende? Denna åtgärd kan inte ångras.',
    dossiers_count: '{n} ärende registrerat',
    dossiers_count_pl: '{n} ärenden registrerade',
    type_particulier: '👤 Privatperson',
    type_professionnel: '🏢 Företag',
    dos_statut_en_attente_informations: 'Väntar på information',
    dos_statut_en_cours_traitement: 'Behandlas',
    dos_statut_attente_validation: 'Väntar på godkännande',
    dos_statut_attente_paiement_solde: 'Väntar på slutbetalning',
    dos_statut_solde_paye: 'Saldo betalt',
    dos_statut_attente_paiement_compta: 'Väntar på betalning från ekonomi',
    dos_statut_paiement_realise: 'Betalning slutförd',
    dos_statut_decline: 'Avvisad',
statut_auto_info: 'Statusen ändras automatiskt baserat på åtgärder i ärendet.',
    date_limite_paiement: 'Sista betalningsdag',
    appel_fonds_pdf: 'Skapa PDF för medelsbegäran',
    appel_fonds_email_pdf: 'Skicka via e-post',
    appel_fonds_dl: 'Laddar ner…',
    benef_montant_facture: 'Vilket totalbelopp har du blivit fakturerad? (€)',
    benef_type_reglement: 'Har du betalat en handpenning eller hela beloppet?',
    benef_type_acompte: 'Handpenning',
    benef_type_totalite: 'Hela beloppet',
    benef_montant_acompte: 'Vilket belopp? (€)',
    benef_modes_paiement: 'Hur har du betalat?',
    benef_mode_carte: 'Bankkort',
    benef_mode_virement: 'Banköverföring',
    benef_mode_cheque: 'Check',
    benef_mode_especes: 'Kontant',
    benef_mode_cadeau: 'Presentkort / Tillgodo / Bröllopslista',
    benef_nb_voyageurs: 'Hur många resenärer berörs?',
    benef_souhait_client: 'Vad önskar du?',
    benef_souhait_remboursement: 'Få återbetalning',
    benef_souhait_maintien: 'Behålla min resa',
    benef_souhait_rapatriement: 'Bli hemtransporterad',
    docs_admin_title: 'Dokument',
    docs_admin_generer_pdf: 'Skapa PDF för medelsbegäran',
    docs_admin_pdf_saved: 'PDF skapad och sparad',
    docs_admin_ajouter: '+ Lägg till dokument',
    docs_admin_nom_label: 'Dokumentets namn',
    docs_admin_aucun: 'Inget dokument registrerat.',
    docs_admin_appel_fonds: 'Medelsbegäran',
    creer_acces_subtitle: "Skapa ett konto så att resenären kan komplettera sitt ärende online.",
    creer_acces_voyageur: "Skapa resenärskonto",
    acces_email: "Resenärens e-post",
    acces_password: "Tillfälligt lösenord",
    acces_generer: "Skapa konto",
    acces_cree: "Konto skapat — vidarebefordra inloggningsuppgifterna till resenären",
    voyageur_space: "Min skadesida",
    voyageur_mon_dossier: "Mitt ärende",
    err_required: "Resebyrå och öppningsdatum krävs",
    warning_manager: "Godkännandet måste bekräftas av en Manager innan förfarandet officiellt öppnas. Denna bekräftelse låser den berörda resebyrån permanent.",
  },

  collecte: {
    title: 'Riskanmälan — Resegaranti',
    dr_ref: 'Referens: DR-V-2401 · arcus-solutions.fr',
    section_renseignements: 'Allmänna uppgifter',
    nom_social: 'Namn eller firmanamn *',
    nom_commercial: 'Varumärke (om annat)',
    directeur: 'Direktör / VD',
    adresse: 'Adress',
    forme_juridique: 'Bolagsform',
    capital_social: 'Aktiekapital',
    siren: 'Organisationsnummer',
    site_internet: 'Webbplats',
    date_creation: 'Bildat datum',
    date_cloture: 'Bokslutsdag',
    nb_agences: "Antal filialer",
    nb_collaborateurs: 'Antal anställda',
    immat_atout_france: "Atout France-nummer",
    rc_pro_numero: "Yrkesansvarsförsäkring nr",
    rc_pro_compagnie: "Försäkringsbolagets namn",
    rc_pro_echeance: 'Förfallodag yrkesansvar',
    banque_title: 'Huvudbank',
    ec_title: 'Revisor',
    correspondant: 'Kontaktperson',
    section_dirigeants: 'Verkställande direktörer',
    dir_nom: 'Efternamn *',
    dir_formations: 'Yrkesutbildningar',
    dir_annees: "Års erfarenhet (turism)",
    dir_pct: '% av aktiekapitalet',
    dir_situations: "Har VD / aktieägare varit i någon av dessa situationer?",
    dir_sauvegarde: 'Rekonstruktionsförfarande',
    dir_redressement: 'Företagsrekonstruktion',
    dir_liquidation: 'Likvidation',
    dir_infos: 'Viktig information du vill meddela oss',
    dir_add: '+ Lägg till VD / aktieägare',
    dir_del: 'Ta bort',
    dir_num: 'VD / Aktieägare',
    section_patrimoine: 'VD:s tillgångar',
    pat_nom: 'VD:s namn',
    pat_estimation: 'Värdering (€)',
    pat_type_immo: 'Typ av fastighetstillgångar',
    pat_adresse_immo: 'Fastighetens adress',
    pat_type_mobilier: 'Typ av lös egendom',
    pat_prets: 'Pågående lån (€)',
    pat_etablissement: 'Långivare',
    pat_capital: 'Investerat kapital (€)',
    pat_add: '+ Lägg till tillgång',
    section_societes: 'Information om aktieägarnas övriga bolag',
    soc_warning: "Vänligen fyll i denna tabell och bifoga den senaste årsredovisningen för varje struktur. Vid tidigare konkurs, ange detta.",
    soc_nom: 'Namn / Firmanamn',
    soc_associe: 'Kopplad delägare',
    soc_date: 'Bildat datum',
    soc_ca: 'Omsättning (N-1) €',
    soc_resultat: 'Nettoresultat (N-1) €',
    soc_add: '+ Lägg till bolag',
    section_presentation: "Kort presentation av din verksamhet / projekt",
    description_label: "Beskriv din verksamhet / ditt projekt *",
    description_placeholder: "Beskrivning av verksamheten eller etableringsprojektet…",
    reseau_label: "Är du medlem / kommer du att gå med i ett nätverk? Om ja, vilket?",
    reseau_placeholder: "T.ex. Selectour, Afat, Thomas Cook…",
    ca_title: "Fördelning av omsättningsvolym (€)",
    ca_forfaits_dist: "Paketresor — Distribution (€)",
    ca_forfaits_prod: "Paketresor — Produktion (€)",
    ca_prestations: "Rena turisttjänster (€)",
    ca_transport: "Rena transporter (€)",
    ca_total: "TOTAL omsättningsvolym (€)",
    clientele_btoc: "B2C-kundkrets (privatpersoner / företag / personalstiftelser)",
    clientele_btob: "B2B-kundkrets (andra turistföretag)",
    clientele_autres: "Övriga kundkretsar",
    mode_distrib: "Distributionssätt (webbplats, filial, nätverk…)",
    fournisseurs_label: "Huvudleverantörer (TO, mottagande agenter, hotell, DMC…)",
    fournisseurs_placeholder: "T.ex. Jet tours, Kuoni, Accor…",
    section_complement: "Kompletterande information",
    engagement_label: "Volymåtagande gentemot dina leverantörer? Specificera om ja",
    delais_label: "Betalningsvillkor / -frister till leverantörer",
    repartition_monde: "Fördelning av verksamheten i världen (%)",
    reglement_title: "Kundernas betalningssätt (%)",
    reglement_especes: "Kontant %",
    reglement_cheque: "Check %",
    reglement_virement: "Överföring / Autogiro %",
    reglement_carte: "Kort %",
    passerelle_label: "Använder du en betalningsgateway (merchant acquirer)?",
    passerelle_nom: "Om ja, vilken",
    passerelle_delai: "Tid för medelöverföring (dagar)",
    section_previsionnel: "Finansiell prognos",
    pct_acompte: "% handpenning vid bokning",
    mois_reservation: "I genomsnitt, hur många månader i förväg bokar kunderna?",
    mois_solde: "Hur många månader före avresa betalas slutbeloppet?",
    montant_moyen: "Genomsnittsbelopp per resenär (€)",
    previsionnel_title: "Omsättningsprognos efter avresedatum — period att garantera",
    previsionnel_desc: "Ta endast hänsyn till omsättningen för utförda tjänster. Exempel: En grupp på 10 personer reser i juli, omsättningen är 10 000 €, ange 10 000 € i juli.",
    previsionnel_col1: "Månad / År",
    previsionnel_col2: "Ursprungligen deklarerade tjänster (€)",
    previsionnel_total: "TOTAL",
    previsionnel_hint: "Ange första månaden — de följande 11 månaderna fylls i automatiskt",
  },

    rcpro_studies: {
    title: "RC Pro-teckningsansökningar under granskning",
  },
  gf_studies: {
    title: "Ärenden under granskning",
    count: "ärende",
    count_plural: "ärenden",
    empty: "Inga ärenden under granskning.",
    col_client: "Kund",
    col_broker: "Mäklare",
    col_submitter: "Inskickat av",
    col_date: "Inskickat den",
    col_actions: "Åtgärder",
    study_btn: "Granska ärendet",
  },
  gf_declarations: {
    title: "Omsättningsdeklarationer",
    count: "ärende",
    count_plural: "ärenden",
    empty: "Ingen väntande deklaration.",
    col_client: "Kund",
    col_broker: "Mäklare",
    col_period: "Deklarerad period",
    col_declared: "Deklarerad den",
    col_amount: "Utfall / Prognos",
    col_actions: "Åtgärder",
    review_btn: "Granska",
    over_forecast: "Över prognos",
    vs_prev: "prognos",
  },
  gf_requests: {
    title: "Begäranden om öppning av finansiell garanti",
    count: "begäran",
    count_plural: "begäranden",
    empty: "Inga väntande öppningsbegäranden.",
    col_client: "Kund",
    col_broker: "Mäklare",
    col_requester: "Sökande",
    col_date: "Begärt den",
    col_actions: "Åtgärder",
    validate: "Godkänn",
    refuse: "Avslå",
    refuse_title: "Avslå begäran",
    refuse_desc: "Ange skäl för avslag för",
    refuse_motif_ph: "Skäl för avslag (valfritt)",
    refuse_confirm: "Bekräfta avslag",
  },
  rcpro: {
    submit_btn: "Skicka teckningsansökan",
    submit_blocked_hint: "Ladda upp alla nödvändiga teckningshandlingar för att skicka in.",
    submit_missing_title: "För att skicka din teckningsansökan återstår:",
    submit_missing_docs: "Teckningshandlingar att ladda upp.",
    submitted_banner: "Teckningsansökan skickad till Arcus Solutions — under granskning. Formuläret är låst under granskningen.",
    submit_confirm_title: "Skicka teckningsansökan?",
    submit_confirm_desc: "Din ansökan (teckningshandlingar) skickas till Arcus Solutions-teamet för granskning. Formuläret låses under granskningen. Du informeras om resultatet.",
    submit_confirm_btn: "Skicka in",
  },
  notes_int: {
    open: "Intern diskussion",
    title: "Intern diskussion",
    scope_client: "Tråd kopplad till denna kund",
    scope_police: "Tråd kopplad till detta avtal",
    empty: "Inga interna anteckningar än. Lägg till en kommentar för att starta historiken.",
    placeholder: "Lägg till en intern kommentar…",
    attach: "Bifoga filer",
    drop_here: "Släpp filer här",
    hint: "Dra och släpp en fil eller ett mejl · Ctrl+Enter för att skicka",
    readonly: "Endast visning för denna profil.",
    delete_confirm: "Radera denna kommentar?",
  },
  gf: { submit_btn: "Skicka ärendet till Arcus", submit_blocked_hint: "Fyll i insamlingsformuläret och ladda upp alla nödvändiga handlingar för att skicka in.", submit_missing_title: "För att skicka ditt ärende till Arcus Solutions återstår att fylla i:", submit_missing_collecte: "Obligatoriska uppgifter som saknas (Informationsinsamling):", submit_missing_docs: "Teckningshandlingar att ladda upp.", submitted_banner: "Ärendet skickat till Arcus Solutions — under granskning. Formuläret är låst under granskningen.", submit_confirm_title: "Skicka ärendet till Arcus Solutions?", submit_confirm_desc: "Ditt ärende (insamling + handlingar) skickas till Arcus Solutions-teamet för granskning. Formuläret låses under granskningen. Du informeras om resultatet.", submit_confirm_btn: "Skicka in", request_open_btn: "Begär öppning av ett ärende för finansiell garanti", request_done_msg: "Din begäran om att öppna ett ärende har skickats till Arcus Solutions-teamet, som återkommer för handläggning så snart som möjligt.", awaiting_validation: "Väntar på godkännande",
    tab_surveillance: "Risköversikt",
    surveillance_intro_title: "Uppföljning av faktisk omsättning",
    surveillance_intro_text: "Vid regelbundna intervall deklarerar kunden sin faktiska omsättning för att kontrollera överensstämmelse med prognosen. Dessa data matar uppföljningen av garantifonden.",
    surveillance_frequency_label: "Övervakningsfrekvens",
    surveillance_freq_trim: "Kvartalsvis",
    surveillance_freq_sem: "Halvårsvis",
    surveillance_freq_not_set: "Ej definierad",
    surveillance_pick_freq: "Välj övervakningsfrekvens för att skapa deklarationsperioderna.",
    surveillance_not_subscribed: "Deklarationsperioderna skapas vid tecknande av försäkringen.",
    surveillance_period: "Period",
    surveillance_declaration_in: "Deklaration förväntas i",
    surveillance_col_month: "Månad",
    surveillance_col_previsionnel: "Prognos",
    surveillance_col_realise: "Utförda tjänster",
    surveillance_col_ecart: "Avvikelse",
    surveillance_total: "Total",
    surveillance_declared_at: "Deklarerad den",
    surveillance_validated_at: "Godkänd den",
    surveillance_declare_btn: "Deklarera till Arcus Solutions",
    surveillance_validate_btn: "Godkänn deklarationen",
    surveillance_status_a_venir: "Kommande",
    surveillance_status_a_declarer: "Att deklarera",
    surveillance_status_declaree: "Deklarerad",
    surveillance_status_validee: "Godkänd",
    surveillance_reset_title: "Ändra frekvens?",
    surveillance_reset_warning: "Att ändra frekvensen tar bort befintliga perioder samt alla redan inmatade deklarationer. Denna åtgärd kan inte ångras.",
    surveillance_reset_confirm: "Bekräfta och återställ",
    create_variation: "Skapa variation",
    renew_procedure: "Skapa förnyelseförfarande",
    terminate_gf: "Säg upp",
    title: 'Resegaranti',
    nav: 'Resegaranti',
    tab_policy: 'Försäkringen',
    tab_tarification_gf: 'Prissättning',
    tarif_add_period: '+ Lägg till period',
    tarif_period: 'Period',
    tarif_date_debut: 'Startdatum',
    tarif_date_fin: 'Slutdatum',
    tarif_exposition: 'Exponering (€)',
    tarif_taux: 'Sats (%)',
    tarif_prime_ht: 'Nettopremie',
    tarif_taxe: 'Skatt (9%)',
    tarif_prime_ttc: 'Bruttopremie',
    tarif_total: 'TOTAL BRUTTOPREMIE',
    tarif_hint: 'Nettopremie = Exponering × Sats · Skatt = 9% · Bruttopremie = Nettopremie + Skatt',
    tab_underwriting: 'Informationsinsamling',
    tab_documents: 'Dokument',
    tab_souscription: 'Tecknandehandlingar',
    create_policy: '+ Ny resegaranti',
    portfolio_title: 'Resegarantiportfölj',
    contexte_label: 'Sammanhang för ansökan *',
    contexte_creation: "Företagsbildning",
    contexte_historique: 'Företag med historik',
    contexte_ajout: "Tillägg av turismverksamhet",
    contexte_hint_creation: 'Företag under bildande — 7 dokument krävs',
    contexte_hint_existant: 'Befintligt företag — 10 dokument krävs',
    collecte_title: 'Riskanmälan — Resegaranti',
    tarification_placeholder_sub: 'Parametrarna kommer att konfigureras i en framtida version.',
    warn_date_effet_locked: "Ändring möjlig men känslig — tänk på att återställa övervakningsperioderna vid behov",
    // ── Payment Graph (onglet Arcus) ──
    tab_payment_graph: "Payment Graph",
    pg_title: "Bond Graph — Teoretisk exponering",
    pg_subtitle: "Automatisk beräkning av risk och premie utifrån den finansiella prognosen.",
    pg_incomplete: "Fyll i ”Finansiell prognos” (omsättningstabellen) i fliken Informationsinsamling för att generera Bond Graph.",
    pg_params_title: "Parametrar från insamlingen",
    pg_param_acompte: "Handpenning",
    pg_param_solde: "Slutbetalning",
    pg_param_reserv: "Bokning i förväg",
    pg_param_solde_delai: "Slutbetalning före avresa",
    pg_months: "månader",
    pg_total_bookings: "Omsättning (år 1)",
    pg_param_missing: "Ange handpennings-% och antal månaders förhandsbokning i insamlingen för en tillförlitlig beräkning.",
    pg_admin_title: "Beräkningsparametrar (Arcus)",
    pg_rate: "Premiesats (%)",
    pg_bond_helper: "Hjälp för Bond level (Omsättning × %)",
    pg_col_month: "Månad",
    pg_col_bookings: "Bookings departing",
    pg_col_cash_received: "Cash Received",
    pg_col_cash_held: "Cash Held",
    pg_col_exposure: "Exposure",
    pg_col_last_bond: "Bond N-1",
    pg_col_bond: "Bond level",
    pg_col_premium: "Premium",
    pg_year1_tag: "ÅR 1",
    pg_year2_tag: "ÅR 2 · projektion",
    pg_total_year1: "TOTALT — År 1",
    pg_annual_ht: "Årlig nettopremie",
    pg_peak_exposure: "Max exponering (år 1)",
    pg_annual_ttc: "Årlig bruttopremie",
    pg_formula_cash: "handpenning × Bookings(månad+förh) + slut × Bookings(månad+slut)",
    pg_formula_premium: "Bond level × sats ÷ 12 · Brutto = Netto × 1,09 (9% skatt)",
    pg_last_bond_hint: "Bond N-1: tom år 1 · fylls automatiskt vid förnyelse (föregående års exponering).",
    // ── Lot 1 : cotation + sections Documents ──
    pg_cotation_title: "Offert (försäkringsförslag)",
    pg_cotation_empty: "Ingen offertperiod definierad.",
    pg_generate_cotation: "Skapa offert",
    pg_regenerate_cotation: "Skapa offert igen",
    pg_cotation_generated: "Offert skapad den",
    pg_cotation_none: "Ingen offert skapad",
    pg_cotation_confirm_title: "Skapa offerten?",
    pg_cotation_confirm_desc: "Offerten sparas och försäkringsförslaget blir tillgängligt under fliken Dokument.",
    pg_cotation_confirm_btn: "Skapa",
    doc_section_projet: "Försäkringsförslag",
    doc_section_contractuelles: "Avtalshandlingar",
    doc_projet_ready: "Offert från",
    doc_projet_locked: "Skapa offerten i fliken Payment Graph för att aktivera försäkringsförslaget.",
    doc_projet_badge_todo: "Att skapa",
    // ── Lot 3 : déclarations + variations ──
    pg_col_declarations: "Declarations",
    pg_period_declared: "Deklarerad period",
    pg_period_vs: "vs prognos",
    pg_over_forecast: "Över prognos",
    pg_create_variation: "Skapa en variation",
    pg_variation_created: "Variation skapad",
    pg_variations_title: "Premievariationer",
    pg_variation_label: "Variation",
    pg_variation_badge_draft: "Utkast",
    pg_variation_badge_done: "Skapad",
    pg_variation_generate: "Skapa premieavisering för variation",
    pg_variation_regenerate: "Skapa premieavisering igen",
    pg_variation_generated: "Premieavisering skapad den",
    pg_variation_confirm_title: "Skapa premieaviseringen för variationen?",
    pg_variation_confirm_desc: "Premieaviseringen för variationen sparas och visas under fliken Dokument, under avtalshandlingarna.",
    pg_variation_confirm_btn: "Skapa",
    doc_section_variations: "Premieaviseringar för variationer",
    doc_variation_label: "Premieavisering för variation",
    // ── Workflow étude/police GF ──
    etude_title: "Ärendegranskning",
    etude_locked_note: "Avsnitt låst — försäkringen är tecknad.",
    numero_projet: "Projektnummer",
    date_effet_prev: "Preliminärt ikraftträdandedatum",
    date_prev_locked_devis: "Låst vid offertstadiet.",
    step_hint_demande_pieces: "Kunden fyller i sitt ärende och skickar det till Arcus.",
    step_hint_en_cours: "Nås automatiskt när kunden skickar in sitt ärende.",
    step_hint_devis: "Nås när försäkringsförslaget skapas.",
    repasser_btn: "Återgå till Begäran om handlingar",
    repasser_confirm_title: "Återställa ärendet till Begäran om handlingar?",
    repasser_confirm_desc: "Formuläret blir redigerbart för kunden igen; redan ifylld information behålls. Ärendet återgår till statusen ”Begäran om handlingar”.",
    repasser_confirm_btn: "Återställ",
    police_locked_note: "Avsnittet aktiveras när försäkringen tecknas.",
    // ── Souscription GF ──
    souscrire_btn: "Teckna försäkringen",
    souscrire_need_date: "Ange ikraftträdandedatum.",
    souscrire_confirm_title: "Teckna försäkringen",
    souscrire_confirm_desc: "Bekräfta uppgifterna nedan för att skapa försäkringen. Avsnittet ”Försäkring” aktiveras och ärendegranskningen låses.",
    souscrire_date_label: "Försäkringens ikraftträdandedatum",
    souscrire_npolice_label: "Försäkringsnummer",
    souscrire_freq_label: "Övervakningsfrekvens",
    souscrire_freq_hint: "Detta val låser frekvensen i fliken Risk Monitoring.",
    souscrire_confirm_btn: "Teckna",
    // ── Tableau parallèle déclarations ──
    pg_group_original: "Payment Graph (prognos)",
    pg_group_declarations: "Deklarationsuppföljning",
    pg_col_updated_exposure: "Updated exposure",
    pg_col_updated_bond: "Updated bond level",
    // ── Lot 1 : bond level par périodes ──
    pg_define_bond: "Ange bond level",
    pg_bond_modal_title: "Ange bond level för en period",
    pg_bond_modal_desc: "Perioden börjar vid den första icke täckta månaden. Välj slutmånad och belopp: varje månad i perioden får detta bond level.",
    pg_bond_modal_confirm: "Ange period",
    pg_bond_period_start: "Start (auto)",
    pg_bond_period_end: "Periodens slut",
    pg_bond_amount: "Bond level-belopp",
    pg_bond_expo_max: "Använd max exponering:",
    pg_bond_periods_recap: "Bond level-perioder",
    pg_bond_periods_none: "Ingen period definierad – klicka på ”Ange bond level” på första månaden.",
    pg_bond_periods_incomplete: "12 månader ännu ej täckta",
    pg_bond_remove_last: "Ta bort senaste",
    pg_bond_reset: "Återställ",
    // ── Lot 2 : cotation auto ──
    pg_cotation_auto_hint: "Offerten genereras automatiskt från bond level-perioderna (datum + exponering + sats).",
    pg_cotation_need_bond: "Definiera först bond level-perioderna i tabellen ovan.",
    pg_cotation_incomplete: "Täck alla 12 månader med bond level-perioder och ange satsen för att generera offerten.",
    // ── Lot 3 : déclarations mois futurs ──
    surveillance_anticipation_hint: "Föregripande möjligt — redigerbart fram till deklarationen, sedan låst.",
    // ── Lot 4 : section variations ──
    pg_variations_hint: "Variationer beräknas automatiskt från validerade deklarationer med ökning, uppdelade per bond level-period.",
    pg_var_peakbond_title: "Peak bond % per period",
    pg_var_period: "Period",
    pg_var_peakbond: "Peak bond %",
    pg_var_booking_initial: "Ursprunglig Booking Departing",
    pg_var_booking_new: "Nytt Booking Departing",
    pg_var_increase: "Ökning",
    pg_var_none: "Ingen variation — ingen validerad deklaration med ökning ännu.",
    pg_var_value: "Variationsvärde",
    pg_var_days: "Dagar",
    pg_variation_see_section: "→ se avsnittet Variationer",
    pg_chart_title: "Bond graph — kurvor",
    surveillance_declare_confirm_title: "Deklarera till Arcus Solutions?",
    surveillance_declare_confirm_desc: "Volymerna nedan skickas till Arcus Solutions för validering. Efter bekräftelse låses denna period permanent och kan inte längre ändras.",
    surveillance_declare_confirm_btn: "Bekräfta deklarationen",
    pg_var_appel_title: "Premieavisering (variation)",
    pg_var_appel_pending_desc: "De väntande variationerna nedan grupperas i en enda premieavisering.",
    pg_var_appel_none: "Ingen variation väntar på premieavisering.",
    pg_var_appel_generate: "Skapa premieavisering",
    pg_var_appel_history: "Skapade aviseringar",
    pg_var_appel_confirm_title: "Skapa premieavisering?",
    pg_var_appel_confirm_desc: "Välj de variationer som ska ingå i denna premieavisering. Omarkerade variationer förblir väntande för en senare avisering.",
    pg_var_appel_confirm_btn: "Skapa aviseringen",
    pg_var_badge_covered: "Ingår i aviseringen från",
    pg_var_badge_pending: "Väntar på avisering",
    pg_table_title: "Payment graph",
    surveillance_declare_validate_btn: "Deklarera och validera",
    surveillance_declare_validate_desc: "Du deklarerar dessa volymer för kundens räkning: perioden deklareras OCH valideras omedelbart och låses därefter permanent. Payment Graph uppdateras.",
    pf_title: "Portfölj Finansiell garanti",
    pf_contracts: "ärenden",
    pf_col_month: "Skapandemånad",
    pf_col_status: "Status",
    pf_col_name: "Ärende",
    pf_col_country: "Land",
    pf_col_broker: "Mäklare",
    pf_col_prev_date: "Förväntat datum",
    pf_direct: "Direkt",
    pf_search: "Kund / Försäkringsnr…",
    pf_filter: "Filtrera",
    pf_filter_search: "Sök…",
    pf_filter_all: "Markera alla",
    pf_filter_none: "Avmarkera alla",
    pf_filter_clear_all: "Rensa alla filter",
    pf_no_rows: "Inget ärende matchar filtren.",
    pg_mgmt_fees: "Förvaltningsavgifter",
  },



  account: {
    title: "Mitt konto",
    breadcrumb: "PERSONLIGT OMRÅDE",
    profile: "Min profil",
    change_password: "Ändra mitt lösenord",
    current_password: "Nuvarande lösenord",
    update_password_btn: "Uppdatera lösenord",
    password_changed: "Lösenordet har ändrats.",
    field_nom: "Fullständigt namn",
    field_email: "E-post",
    field_role: "Status",
  },
  utilisateurs: { col_last_login: "Senaste inloggning", never_connected: "Aldrig inloggad",
    create_mode_label: "Metod för kontoskapande",
    mode_link: "Skicka en aktiveringslänk",
    mode_password: "Ange ett lösenord",
    password_label: "Lösenord",
    password_ph: "Minst 8 tecken",
    password_info: "Kontot kan användas direkt med detta lösenord. Inget e-postmeddelande skickas.",
    pwd_too_short: "Lösenordet måste innehålla minst 8 tecken.",
    title: "Användarkonton",
    count: "konto",
    count_plural: "konton",
    create_btn: "+ Skapa användare",
    search_placeholder: "Sök efter namn eller e-post…",
    filter_all: "Alla",
    statut_actif: "Aktiv",
    statut_inactif: "Inaktiv",
    breadcrumb: "ANVÄNDARKONTON",
    new_title: "Nytt konto",
    edit_title: "Redigera konto",
    field_nom: "Fullständigt namn",
    field_email: "E-post",
    field_role: "Status (roll)",
    field_client: "Tilldelad kund",
    field_courtier: "Kopplad mäklare",
    field_statut: "Kontostatus",
    create_info: "Ett aktiveringsmail skickas till den angivna adressen. Användaren skapar sitt lösenord via länken som mottagits.",
    create_and_send: "Skapa och skicka länk",
    send_reset: "Skicka återställningslänk",
    reset_password: "Återställ lösenord",
    reset_sent_simple: "Återställningslänk skickad",
    saved: "Ändringar sparade",
    created: "Konto skapat — e-post skickad",
    delete_confirm: "Ta bort kontot permanent för",
  },
  docs_souscription: {
    title: 'Tecknandehandlingar',
    subtitle: 'Handlingar att samla in före tecknande',
    doc_projet_signe: "Underskrivet försäkringsutkast",
    doc_certificat: "Registreringsbevis",
    doc_rib: 'Kontouppgifter',
    doc_releve_sinistre: 'Skadeutdrag',
    rib_condition: 'Krävs — annan betalningsfrekvens än årlig',
    releve_condition: 'Krävs — risk redan försäkrad',
    add_doc: '+ Lägg till obligatoriskt dokument',
    add_doc_placeholder: "T.ex. Intyg från tidigare försäkringsgivare",
    add_doc_label: 'Dokumentets benämning',
    upload_btn: 'Ladda upp',
    replace_btn: 'Ersätt',
    preview_btn: 'Visa',
    accept_btn: 'Godkänn',
    refuse_btn: 'Avvisa',
    status_attente: 'Väntar',
    status_uploade: 'Uppladdat',
    status_accepte: 'Godkänt',
    status_refuse: 'Avvisat',
    refuse_category: 'Avvisningskategori *',
    refuse_category_placeholder: '— Välj kategori —',
    refuse_detail: 'Förtydligande (valfritt)',
    refuse_email_btn: '📧 Skicka avvisningsmail till kunden',
    refuse_email_title: 'E-post — Avvisade dokument',
    refuse_email_copy: 'Kopiera',
    refuse_email_open: 'Öppna i e-postprogram',
    refuse_email_copied: 'Kopierat!',
    refuse_email_subject: 'Ditt ärende — Dokument att justera',
    refuse_no_refused: 'Inga avvisade dokument hittills.',
    refuse_title: 'Motivering för avvisning',
    refuse_label: 'Avvisningsorsak *',
    refuse_placeholder: "T.ex.: Oläsligt dokument, fel dokument…",
    refuse_email_note: 'Denna kommentar skickas via e-post till kunden.',
    refuse_confirm: 'Bekräfta avvisning',
    locked_msg: 'Godkänt',
    rejected_comment: 'Orsak:',
    completion: 'godkänd(a)',
    accept_confirm: 'Godkänna detta dokument?',
    file_size: 'Max 20 MB — PDF, bilder, Word',
    unlock_btn: 'Lås upp',
    unlock_confirm: 'Återställa detta dokument till att vänta på godkännande?',
    doc_gf_cert_immat: "Registreringsbevis",
    doc_gf_statuts: "Bolagsordning",
    doc_gf_cv_dirigeant: 'CV för verkställande direktör',
    doc_gf_piece_id: "ID-handling för verkställande direktör",
    doc_gf_presentation_projet: 'Projektpresentation',
    doc_gf_previsionnel: "Detaljerad verksamhetsprognos",
    doc_gf_cgv: 'Allmänna villkor',
    doc_gf_presentation_activites: 'Verksamhetspresentation',
    doc_gf_previsionnel_annuel: "Verksamhetsprognos för året som ska garanteras",
    doc_gf_bilan_cr: 'Senaste årsredovisning och detaljerad resultaträkning',
    doc_gf_attestation_rcpro: 'Gällande intyg om yrkesansvarsförsäkring',
    doc_gf_attestation_fonds: 'Intyg om förvarade toppbelopp',
    readonly_banner: 'Skrivskyddad vy — endast uppladdning och visning',
    broker_readonly: 'Som mäklare kan du endast visa kundernas ärenden.',
    address_siege: 'Huvudkontorets adress',
    broker_status_locked: 'Intressent — status bestäms av Arcus handläggare',
    accepted_label: 'godkänd(a)',
    required_label: 'Krävs',
    delete_btn: '🗑 Ta bort',
    doc_contrat_reservation: "Kopia av bokningsavtal med resebyrån",
    doc_preuve_paiement: 'Betalningsbevis',
    doc_bon_voucher: 'Ej använd voucher (i förekommande fall)',
    delete_confirm: 'Ta bort detta dokument?',
    // ── Verrou pack + ZIP (Lot C) ──
    lock_pack: "Lås handlingarna",
    unlock_pack: "Lås upp handlingarna",
    generate_zip: "Skapa ZIP-paket",
    lock_confirm: "Lås handlingspaketet? Inga ändringar är möjliga förrän det låses upp.",
    unlock_pack_confirm: "Lås upp handlingspaketet för att tillåta ändringar?",
    zip_confirm: "Skapa ZIP för handlingspaketet?",
    zip_coming: "ZIP-generering kommer snart.",
    pack_locked_note: "Handlingar låsta.",
    pack_ready_note: "Alla obligatoriska handlingar är validerade.",
  },
  chat: {
    open: "Öppna chatt",
    minimize: "Minimera",
    with_arcus: "Konversation med Arcus",
    no_conv: "Ingen konversation",
    select_conv: "Välj en konversation",
    no_conv_yet: "Ingen konversation ännu",
    no_messages_yet: "Inga meddelanden",
    send_first_message: "Skicka ditt första meddelande nedan",
    message_placeholder: "Skriv ett meddelande…",
    participants: "medlemmar",
    you: "Du",
    add: "Lägg till",
    add_admin: "Lägg till Arcus-medlem",
    remove_participant: "Ta bort denna medlem",
    confirm_remove_participant: "Ta bort denna medlem från konversationen?",
    all_admins_already: "Alla administratörer är redan medlemmar",
    loading_error: "Konversation otillgänglig",
    back_list: "Tillbaka till konversationer",
  },
  it_delete: {
    title: "God Mode — Tvingad borttagning",
    god_mode: "GOD MODE — IT",
    entity_client: "Kund",
    entity_police: "Försäkring",
    entity_intermediaire: "Förmedlare",
    about_to_delete: "Du är på väg att permanent ta bort",
    also_deleted: "KOPPLADE OBJEKT TAS BORT I KASKAD",
    no_cascade: "Inga kopplade objekt att ta bort.",
    polices: "Försäkringar",
    amendements: "Tilläggsavtal",
    renouvellements: "Förnyelser (kopplingar rensade)",
    clients_unlinked: "Kopplade kunder (blir direkta)",
    irreversible: "Denna åtgärd kan inte ångras.",
    confirm_btn: "Ta bort permanent",
    impact_error: "Kunde inte beräkna påverkan.",
    delete_error: "Borttagning misslyckades.",
    dossiers_linked: "Kopplade ärenden (betalningar påverkade)",
  },

  prestataires_section: {
    title: "Leverantörer & Researrangörer",
    breadcrumb: "LEVERANTÖRER",
    count: "leverantör",
    count_plural: "leverantörer",
    contacts_count: "kontakt",
    contacts_count_plural: "kontakter",
    create_btn: "+ Ny leverantör",
    new_title: "Ny leverantör",
    search_placeholder: "Sök efter namn, stad, organisationsnummer…",
    iban_set: "IBAN registrerat",
    tab_infos: "Leverantören",
    tab_contacts: "Kontakter",
    tab_bank: "Bankinformation",
    field_nom: "Leverantörens namn",
    field_adresse_1: "Adress 1",
    field_adresse_2: "Adress 2",
    field_code_postal: "Postnummer",
    field_ville: "Stad",
    field_numero_entreprise: "Organisationsnummer",
    field_notes: "Interna anteckningar",
    field_numero_compte: "Kontonummer",
    field_iban: "IBAN",
    field_swift: "SWIFT- / BIC-kod",
    adresse_placeholder: "Husnummer och gata",
    numero_placeholder: "Momsnummer, organisationsnummer…",
    notes_placeholder: "Nyttig info: typ av verksamhet, betalningsvillkor…",
    bank_warning: "Denna information används automatiskt vid skadeutbetalningar med bibehållen resa.",
    err_nom: "Leverantörens namn krävs.",
  },

  phase_b: {
    count: "ärende",
    count_plural: "ärenden",
    empty: "Inget ärende i denna kategori.",
    col_numero: "Ärende- / Förfarande-nr",
    col_agence: "Resebyrå",
    col_beneficiaire: "Förmånstagare",
    col_montant: "Belopp",
    col_date_action: "Datum",
    col_par: "Av",
    confirm_title: "Bekräfta åtgärd?",
    refus_banner_title: "Ärende avvisat av Manager — orsak:",
    send_validation_title: "Skicka till Manager för godkännande",
    send_validation_desc: "När det skickats väntar ärendet på Manager-godkännande före betalning.",
    send_validation_btn: "Skicka för godkännande",
    manager_validation_title: "Manager-godkännande krävs",
    manager_validation_desc: "Detta ärende är klart för slutgodkännande innan det skickas till Accounts.",
    validate_btn: "Godkänn",
    refuse_btn: "Avvisa",
    refuse_modal_title: "Avvisningsorsak",
    refuse_modal_desc: "Ärendet återgår till status \"Pågår\". Orsaken är synlig för Admin.",
    refuse_motif_placeholder: "Ange avvisningsorsaken…",
    refuse_confirm_btn: "Bekräfta avvisning",
    ready_to_pay_title: "Klart för betalning",
    ready_to_pay_desc: "Manager har godkänt detta ärende. Accounts kan nu markera betalningen som utförd.",
    mark_paid_btn: "Markera som betald",
    mark_paid_confirm_title: "Bekräfta utförd betalning?",
    mark_paid_confirm_desc: "Efter bekräftelse går ärendet till status \"Betalning utförd\" och låses.",
    mark_paid_confirm_btn: "Bekräfta betalning",
  },
  pending_validation: {
    title: "Väntar på Manager-godkännande",
    subtitle: "Ärenden skickade av Admin, väntar på slutgodkännande av Manager.",
  },
  pending_payment: {
    title: "Väntar på betalning",
    subtitle: "Ärenden godkända av Manager, väntar på betalning av Accounts.",
    action_mark_paid: "Markera som betald",
    confirm_mark_paid: "Markera detta ärende som betalt:",
    download_btn: "Generera fil med väntande betalningar",
  },
  pending_balances: { col_received: "Mottaget", col_remaining: "Återstår",
    title: "Utestående saldon",
    subtitle: "Saldon som återstår att inkassera från resenärer",
    download_btn: "Generera Excel-fil",
    downloading: "Genererar…",
    empty: "Ingen medelsbegäran genererad ännu.",
    paid: "Betald",
    unpaid: "Väntar",
    col_file: "Ärende-nr",
    col_agency: "Byrå",
    col_beneficiary: "Förmånstagare",
    col_generated: "Genererad",
    col_deadline: "Tidsfrist",
    col_balance: "Saldo",
    col_paid: "Status",
  },
  closed_dossiers: {
    title: "Avslutade ärenden",
    subtitle: "Betalda och avslutade ärenden.",
    download_btn: "Ladda ner skadesammanfattning",
  },

  phase_c: {
    section_title: "Leverantörer att betala (resan behålls)",
    section_subtitle: "Välj en eller flera leverantörer att betala för att klienten ska kunna behålla resan.",
    add_prestataire: "Lägg till leverantör",
    prestataire_num: "Leverantör ",
    select_prestataire: "Leverantör",
    select_placeholder: "Välj leverantör",
    amount: "Belopp",
    reference: "Betalningsreferens",
    reference_placeholder: "T.ex. Faktura nr…",
    description: "Beskrivning",
    description_placeholder: "T.ex. Hotell 2 nätter, Returflyg…",
    bank_locked: "Bankuppgifter (låsta — från central leverantörsprofil)",
    location: "Plats",
    total: "Totalt leverantörsbetalningar",
    empty: "Ingen leverantör tillagd. Klicka på \"Lägg till leverantör\" för att börja.",
  },

  voyageur_intro: {
    title: "Välkommen till ditt ärendeområde för ersättningsanspråk",
    body: "Fyll i informationen om din reseakt och skicka in de dokument som krävs för att behandla ditt ärende.",
    submit_title: "Är din akt komplett?",
    submit_desc: "När den skickats in kommer din akt att skickas till våra team för behandling.",
    submit_btn: "Skicka in min akt",
    submit_confirm_title: "Skicka in din akt?",
    submit_confirm_desc: "Kontrollera att all din information och alla underlag är korrekta. Efter inlämning övergår din akt till behandling.",
    submit_confirm_btn: "Bekräfta inlämning",
    status_section: "Status för din akt",
    status_msg_attente: "Vi väntar på att du ska fylla i din information, skicka in dina underlag och sedan skicka in din akt.",
    status_msg_traitement: "Din akt behandlas av våra team. Du kommer att informeras om förloppet.",
    status_msg_validation: "Din akt väntar på slutligt godkännande av vårt team.",
    status_msg_paiement: "Din akt har godkänts. Betalningen behandlas.",
    status_msg_solde_paye: "Saldot har mottagits. Ditt ärende behandlas fortfarande.",
    status_msg_realise: "Betalningen har genomförts. Din akt är avslutad.",
    status_msg_decline: "Tyvärr kunde din akt inte godkännas. Kontakta oss för mer information.",
  },

  phase_d4: {
    lock: "Lås",
    unlock: "Lås upp",
    locked: "Låst",
    lock_paiements: "Lås betalningar",
    unlock_paiements: "Lås upp betalningar",
    date_naissance: "Förmånstagarens födelsedatum",
    sanction_title: "Sanktionskontroll",
    sanction_btn: "Sanktionskontroll utförd",
    sanction_done: "Sanktionskontroll utförd — betalningarna är låsta.",
    sanction_undo: "Ta bort lås (Manager)",
    validation_checklist: "Villkor för att begära godkännande",
    cond_paiements_locked: "Betalningar låsta",
    cond_docs_approved: "Alla underlag godkända",
    cond_sanction: "Sanktionskontroll utförd",
    cond_facture: "Leverantörsfaktura(or) uppladdade",
    cond_appel_fonds_paye: "Medelsbegäran markerad som betald",
    request_validation_title: "Begär godkännande av ärendet",
    request_validation_desc: "Alla villkor är uppfyllda. Ärendet låses och skickas till Manager.",
    request_validation_btn: "Begär godkännande",
    validation_locked_hint: "Knappen för att begära godkännande visas när alla villkor ovan är uppfyllda.",
    decline_btn: "Avvisa ärendet",
    decline_modal_title: "Avvisa detta ärende?",
    decline_modal_desc: "Ärendet får status \"Avvisad\" och stängs. Du kan ange en orsak.",
    decline_motif_placeholder: "Orsak till avvisning (valfritt)…",
    decline_confirm_btn: "Bekräfta avvisning",
  },
  phase_d4_facture: {
    title: "Leverantörsfaktura",
    upload: "Ladda upp faktura",
    replace: "Ersätt",
   view: "Visa", save_row_first: "Spara denna leverantör först för att bifoga dess faktura.",},
  phase_d5: {
    marquer_paye: "Markera som betald",
    annuler_paye: "Avbryt betalning",
    paye_badge: "Betald",
  },
  phase_solde: { af_confirm_btn: "Bekräfta att medelsbegäran skickats", af_confirm_title: "Bekräfta att medelsbegäran skickats?", af_confirm_desc: "Detta flyttar ärendet till ”Väntar på saldobetalning”, visar permanent avsnittet Saldohantering och låser generering av en ny medelsbegäran. Åtgärden kan inte ångras.", af_confirmed_badge: "Medelsbegäran bekräftad",
    admin_valid_title: "Validering av administrativt ärende",
    admin_valid_desc: "Bekräfta att informationen och underlagen är korrekta (formell validering).",
    admin_valid_done: "Administrativt ärende validerat. Du kan generera medelsbegäran.",
    admin_valid_btn: "Validera administrativt ärende",
    admin_valid_cancel: "Avbryt validering",
    admin_valid_need_docs: "Alla underlag måste vara godkända före validering.",
    gen_blocked: "Validera det administrativa ärendet för att generera medelsbegäran",
    section_title: "Hantering av restbetalning",
    balance_due: "Saldo att betala",
    deadline: "Betalningsfrist",
    received_title: "Mottagna betalningar",
    received_empty: "Inga mottagna betalningar registrerade.",
    add_received: "Lägg till mottagen betalning",
    col_date: "Mottagningsdatum",
    col_emetteur: "Betalningsavsändare",
    col_emetteur_ph: "Avsändarens namn",
    col_montant: "Betalat belopp",
    total_received: "Totalt mottagna medel",
    remaining: "Återstår att ta emot",
    mark_paid_btn: "Markera som betald",
    unlock_btn: "Lås upp",
    confirm_recu_btn: "Bekräfta mottagande av saldo",
    recu_confirmed: "Mottagande av saldo bekräftat",
    recu_cancel: "Avbryt bekräftelse",
    save_confirm_title: "Spara mottagna betalningar?",
    save_confirm_desc: "De angivna betalningsfälten låses. Du kan låsa upp dem senare vid behov.",
    save_confirm_btn: "Spara och lås",
    recu_confirm_title: "Bekräfta mottagande av saldo?",
    recu_confirm_desc: "Saldot har mottagits i sin helhet. Denna åtgärd markerar ärendet som betalt.",
    recu_confirm_btn: "Bekräfta mottagande",
    cond_prestataire_facture: "Minst en leverantör sparad med faktura",
    validation_lock_banner: "Ärendet skickat för validering. Det är låst tills chefen beslutar.",
    send_validation_title: "Skicka för validering",
    send_validation_desc: "Skicka ärendet till chefen för validering av leverantörsbetalningar.",
    send_validation_btn: "Skicka för validering",
    send_validation_confirm_title: "Skicka ärendet för validering?",
    send_validation_confirm_desc: "Ärendet skickas till chefen och låses helt tills beslut fattas.",
    send_validation_confirm_btn: "Skicka för validering",
  },
  phase_d4b: {
    entreprise_nom: "Företagsnamn",
    resp_nom: "Efternamn juridiskt ombud",
    resp_prenom: "Förnamn juridiskt ombud",
    date_naissance: "Födelsedatum",
    nationalite: "Nationalitet",
    sanction_label: "Sanktionskontroll utförd",
    sanction_confirmed: "Sanktionskontroll bekräftad",
  },

  gestiondoc: {
    title: "Dokumenthantering",
    subtitle: "Dokumentmallar — ladda upp en ny version när en mall ändras.",
    add_template: "Lägg till mall",
    cat_gf: "Finansiell garanti",
    cat_rc_pro: "Yrkesansvar",
    cat_commun: "Gemensam",
    cat_sinistre: "Skador",
    no_file: "Ingen fil",
    download: "Ladda ner",
    upload_new: "Ny version",
    history: "Historik",
    systeme_tag: "Katalog",
    custom_tag: "Anpassad",
    inactive: "Inaktiv",
    active: "Aktiv",
    delete_confirm: "Ta bort denna anpassade mall?",
    empty: "Ingen mall.",
    hist_title: "Versionshistorik",
    current_tag: "Aktuell",
    modal_upload_title: "Ladda upp en ny version",
    modal_file: ".docx- eller .pdf-fil",
    modal_notes: "Versionsanteckning (valfritt)",
    modal_upload_btn: "Ladda upp",
    drop_hint: "Dra en fil hit eller klicka för att bläddra",
    add_title: "Ny mall",
    add_nom: "Mallnamn",
    add_categorie: "Kategori",
    add_desc: "Beskrivning",
    add_btn: "Skapa mall",
  },
};

export default sv;
